import { render, staticRenderFns } from "./ROITableMIS.vue?vue&type=template&id=135c51cb&scoped=true&"
import script from "./ROITableMIS.vue?vue&type=script&lang=js&"
export * from "./ROITableMIS.vue?vue&type=script&lang=js&"
import style0 from "./ROITableMIS.vue?vue&type=style&index=0&id=135c51cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c51cb",
  null
  
)

export default component.exports